import React from 'react';
import Header from '../components/user/Header';
import SideBar from '../components/user/SideBar';
import Breadcrumbs from '../components/user/Breadcrumbs';
import WorkspaceLayout from './WorkspaceLayout';
import { UserCourseProvider } from '../contexts/UserCourseContext';

export default function UserLayout({ children }) {
  return (
    <UserCourseProvider>
      <WorkspaceLayout Header={Header} SideBar={SideBar} Breadcrumbs={Breadcrumbs}>
        {children}
      </WorkspaceLayout>
    </UserCourseProvider>
  );
}
